
export default {
  data() {
    return {
      active: '',
      searchActive: false,
      searchKeywords: '',
      navList: [],
      isFixed: false
    }
  },
  computed: {
    isXC() {
      return this.$route.name != 'index';
    }
  },
  async fetch() {
    try {
      this.navList = await this.$axios.$get('/channel/channelTree.do?sid=483');
    } catch(err) {
      console.log(err);
    }
  },
  mounted() {
    // 导航吸顶
    window.addEventListener('scroll', () => {
      if (window.scrollY > 30) {
          this.isFixed = true;
      } else {
          this.isFixed = false;
      }
    });
  }
}
